module.exports = __webpack_public_path__ + "static/media/testEnd.0c75a4a0.jpg";